import { Icon, IconProps } from "../";

export const CreditCardIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M22 18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V10.5H22V18ZM5 16C4.44772 16 4 16.4477 4 17C4 17.5523 4.44772 18 5 18H7.5C8.05228 18 8.5 17.5523 8.5 17C8.5 16.4477 8.05228 16 7.5 16H5ZM11 16C10.4477 16 10 16.4477 10 17C10 17.5523 10.4477 18 11 18H13.5C14.0523 18 14.5 17.5523 14.5 17C14.5 16.4477 14.0523 16 13.5 16H11ZM20 4C21.1046 4 22 4.89543 22 6V8H2V6C2 4.89543 2.89543 4 4 4H20Z" />
    </Icon>
  );
};
